import admin from "./adminApi";
import auth from "./authApi";
import session from "./sessionApi";
import member from "./memberAPI";
import program from "./programApi";
import travelStats from "./travelStatsApi";
import attractions from "./attractionsApi";
import favorites from "./favoritesApi";
import contactMethods from "./contactMethodsApi";
import logging from "./loggingApi";
import sendgrid from "./sendgridApi";

export default {
  admin,
  auth,
  member,
  program,
  session,
  travelStats,
  attractions,
  favorites,
  contactMethods,
  logging,
  sendgrid,
};
